// components/Layout.js
import React from 'react';
import Navbar from '../Navbar/Navbar.jsx';
import {Footer} from '../Footer/Footer.jsx';
import PromoBar from '../PromoBar/PromoBar.jsx';

const Layout = ({ children, hideNavbar = false, hideFooter = false, showPromoBar = false }) => {
  return (
    <>
      {!showPromoBar && <PromoBar />}
      {!hideNavbar && <Navbar />}  
      {children}
      {!hideFooter && <Footer />}
    </>
  );
};

export default Layout;